import { Router } from '@angular/router';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import {
  AuthenticateSurvey,
  AuthStateModel,
  Login,
  LogoutSucceeded,
  SeamlessLogin
} from './auth.model';
import { AuthService } from './auth.service';
import { SurveyAuthService } from './survey-auth.service';

@State<AuthStateModel>({
  name: 'auth'
})
export class AuthState {
  @Selector()
  static token(state: AuthStateModel) {
    return state.token;
  }

  constructor(
    private store: Store,
    private authService: AuthService,
    private surveyAuthService: SurveyAuthService,
    private router: Router
  ) {}

  @Action(Login)
  login({ patchState }: StateContext<AuthStateModel>, { payload }: Login) {
    return this.authService.logIn(payload.email, payload.password).pipe(
      tap((token: string) => {
        patchState({ token, email: payload.email });
      })
    );
  }

  @Action(SeamlessLogin)
  seamlessLogin(
    { patchState }: StateContext<AuthStateModel>,
    { payload }: SeamlessLogin
  ) {
    return this.authService.seamlessLogin(payload.email, payload.token).pipe(
      tap((token: string) => {
        patchState({ token, email: payload.email });
      })
    );
  }

  @Action(AuthenticateSurvey)
  authenticateSurvey(
    { patchState }: StateContext<AuthStateModel>,
    { payload }: AuthenticateSurvey
  ) {
    return this.surveyAuthService.authenticateWithToken(payload).pipe(
      tap((surveyToken: string) => {
        patchState({ surveyToken });
      })
    );
  }

  @Action(LogoutSucceeded)
  logoutSucceeded({ setState }: StateContext<AuthStateModel>) {
    return setState({});
  }
}
